<template>
  <div>
    <div class="search">
        <gmap-autocomplete @place_changed="setPlace" placeholder="Hledat dle města nebo okresu" :options="options"/>
        <contact-contact-list v-if="place"/>
    </div>
    <div class="map">
        <contact-map/>
    </div>
  </div>
</template>

<script>
    import isEmpty from 'lodash/isEmpty';
    import {mapActions} from 'vuex';
    import {NAMESPACE} from './store';
    import {FETCH_CONTACT_BY_ADDRESS} from './action';
    import ContactContactList from './ContactList';
    import ContactMap from './Map';

    export default {
        name: 'ContactSearchTab',
        components: {
            ContactMap,
                ContactContactList
        },
        data() {
            return {
                place: null,
                options: {
                    types: ['(cities)'],
                    componentRestrictions: {country: "cz"}
                }
            }
        },
        methods: {
            ...mapActions(NAMESPACE, [FETCH_CONTACT_BY_ADDRESS]),
            setPlace(place) {
                this.place = place;
                if (!isEmpty(place)) {
                    const {formatted_address} = place;
                    this[FETCH_CONTACT_BY_ADDRESS](formatted_address);
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/contact/SearchTab.vue